import {
  Avatar,
  CircularProgress,
  Grid,
  Typography,
  IconButton
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import useStyles from './useStyles'
import { useDispatch } from 'react-redux'
import { getSuborganizations } from '../../../../redux/actions/Suborganizations'
import { NavLink } from 'react-router-dom'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'

export const BoxSuborganization = ({ item = null }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [suborg, setsuborg] = useState(null)
  const dispatch = useDispatch()

  const getSubOrg = async () => {
    setLoading(true)
    const response = await dispatch(
      getSuborganizations(item.baseSuborganizationId)
    )
    setsuborg(response)
  }

  useEffect(async () => {
    if (item) {
      setLoading(true)
      await getSubOrg()
      setLoading(false)
    }
  }, [item])

  if (loading) {
    return (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Estudio asociado
          </Typography>
        </Grid>
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress color="success" />
        </Grid>
      </Grid>
    )
  }
  if (!suborg) {
    return (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Estudio asociado
          </Typography>
        </Grid>
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#485450'
            }}
          >
            No se encontró el estudio asociado
          </Typography>
        </Grid>
      </Grid>
    )
  }
  return (
    suborg && (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Estudio asociado
          </Typography>
        </Grid>
        <Grid
          container
          className={classes.boxEstudio}
        >
          <Grid item style={{ marginLeft: 5 }}>
            <Avatar
              sx={{
                bgcolor: suborg.suborganizationAvatar.color,
                width: 60,
                height: 60
              }}
            >
              {suborg.suborganizationAvatar.initials}
            </Avatar>
          </Grid>
          <Grid item style={{ marginLeft: 10 }}>
            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              {suborg.suborganizationName}
            </Typography>

            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              {suborg.suborganizationCuit}
            </Typography>
          </Grid>

          <NavLink
            to={`/storage/recycle/${item.baseSuborganizationId}`}
            className={classes.boxNav}
          >
            <IconButton className={classes.boxButton}>
              <Inventory2OutlinedIcon className={classes.hoverButton} />
              <Typography className={classes.typographyStyle}>
                Ver papelera interna
              </Typography>
            </IconButton>
          </NavLink>
          <NavLink
            to={`/ME/declarations/${item.baseSuborganizationId}/declarations`}
            className={classes.boxNav}
          >
            <IconButton className={classes.boxButton}>
              <ReceiptLongIcon className={classes.hoverButton} />
              <Typography className={classes.typographyStyle}>
                Ver declaraciones
              </Typography>
            </IconButton>
          </NavLink>
        </Grid>
      </Grid>
    )
  )
}
